import * as React from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { SnapshotSearchDocument, SnapshotSearchEvent } from "./types";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";

interface Props {
  searchId: string;
  setThinking: (thinking: string) => void;
  setDocuments: (documents: SnapshotSearchDocument[]) => void;
  setIsProcessing: (isProcessing: boolean) => void;
  setSnapshotCollectionOutcomes: (outcomes: BusinessReportOutcome[]) => void;
}

export const SnapshotCollectionsOutcomesSearchWebsocket: React.FC<Props> = ({
  setDocuments,
  searchId,
  setThinking,
  setSnapshotCollectionOutcomes,
  setIsProcessing,
}) => {
  const { lastJsonMessage, readyState, sendJsonMessage } = useWebSocket<SnapshotSearchEvent>(
    "/pf-business-reports/ws",
    {
      shouldReconnect: event => event?.code !== 1000,
      reconnectInterval: 3000,
      skipAssert: true,
    },
  );

  React.useEffect(() => {
    if (readyState === ReadyState.OPEN && searchId) {
      sendJsonMessage({ query_id: searchId });
    }
  }, [readyState, searchId, sendJsonMessage]);

  React.useEffect(() => {
    if (!lastJsonMessage) return;
    if (lastJsonMessage.event === "relevant_fields") {
      setThinking(JSON.parse(lastJsonMessage.context).reasoning);
    } else if (lastJsonMessage.event === "documents") {
      const documents = JSON.parse(lastJsonMessage.context).documents;
      setDocuments(documents);
    } else if (lastJsonMessage.event === "search_response") {
      setSnapshotCollectionOutcomes(JSON.parse(lastJsonMessage.context).results);
      setIsProcessing(false);
    }
  }, [lastJsonMessage, setDocuments, setIsProcessing, setSnapshotCollectionOutcomes, setThinking]);

  return null;
};
